import featureflagService from "@/service/feature-flag/feature-flag.service";

export const isExclusiveProductEnabled = () => {
    return featureflagService.isEnabled('exclusive-products-enabled');
};

export const isPricingVisibilityPermsEnabled = () => {
    return featureflagService.isEnabled('pricing-visibility-permission');
};